import React from "react"
import { Descriptions } from "antd"

function MerchantDescription({ title, column, merchant }) {
  return (
    <Descriptions title={title} column={column}>
      <Descriptions.Item label="Name">{merchant.name}</Descriptions.Item>
      {merchant.phone && (
        <Descriptions.Item label="Phone">
          {merchant.phone.number}
        </Descriptions.Item>
      )}
      {merchant.email && (
        <Descriptions.Item label="Email">
          {merchant.email.email}
        </Descriptions.Item>
      )}
      <Descriptions.Item label="Address">
        {merchant.address?.street1} {merchant.address?.street2}{" "}
        {merchant.address?.city}, {merchant.address?.state}{" "}
        {merchant.address?.zip}
      </Descriptions.Item>
    </Descriptions>
  )
}

export default MerchantDescription
